// extracted by mini-css-extract-plugin
module.exports = {"menu":"sidebar-pane-module__menu___1JZXf","pane":"sidebar-pane-module__pane___sR-Em","container":"sidebar-pane-module__container___1njU6"};